import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode } from "vue"

import { useI18n } from 'vue-i18n';

// 使用i18n进行国际化

export default /*@__PURE__*/_defineComponent({
  __name: 'MollyProductDetail',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"common-layout\"><h1>产品详情页</h1></div><div class=\"productDetail_one\"><img src=\"https://newrockb2b.oss-cn-shenzhen.aliyuncs.com/images/1760170238822_2e8b810eea3411f3d7a7c45d5332a832.jpg\"></div><div class=\"productDetail_two\"><div class=\"two_left\"><div class=\"two_left_top\"><img src=\"https://s.niucache.com/static-shop/NiuHome/kqi3-cn/left-t.png\"></div><div class=\"two_left_bottom\"><img src=\"https://s.niucache.com/static-shop/NiuHome/kqi3-cn/left-b.png\"></div></div><div class=\"two_right\"><img src=\"https://s.niucache.com/static-shop/NiuHome/kqi3-cn/right-c.jpg\"></div></div><div class=\"productDetail_three\"><div class=\"three_top\"><img src=\"https://s.niucache.com/static-shop/NiuI18n/kqi/model-03-3.png\"></div><div class=\"three_middle\"><div class=\"three_middle_left\"><img src=\"https://s.niucache.com/static-shop/NiuI18n/kqi/model-03-4.png\"></div><div class=\"three_middle_right\"><img src=\"https://s.niucache.com/static-shop/NiuI18n/kqi/model-03-5.png\"></div></div><div class=\"three_bottom\"><img src=\"https://s.niucache.com/static-shop/NiuHome/kqi3-cn/blue.png\"></div></div>", 4))
}
}

})